export default __webpack_public_path__ + "static/media/report_23.7aa90c58.png";